export default __webpack_public_path__ + "static/1782-c7189b773d8574882c5e1b60e1483fff.gif";